// Sidebar navigation, grouped into sections. Topbar uses it too to name the current page.
// roles: the item is shown when the user has at least one of them
export const menuSections = [
    {
        title: 'Competition',
        items: [
            { title: 'Matches', to: '/matches', icon: 'mdi-gamepad-variant-outline', roles: ['ROLE_ADMIN', 'ROLE_STATS'] },
            { title: 'Cup', to: '/cups', icon: 'mdi-trophy', roles: ['ROLE_ADMIN'] },
            { title: 'Leagues', to: '/leagues', icon: 'mdi-podium-gold', roles: ['ROLE_ADMIN'] },
            { title: 'League Groups', to: '/league-groups', icon: 'mdi-group', roles: ['ROLE_ADMIN'] },
            { title: 'Seasons', to: '/seasons', icon: 'mdi-calendar', roles: ['ROLE_ADMIN'] },
            { title: 'Staff', to: '/staff', icon: 'mdi-account-tie-outline', roles: ['ROLE_ADMIN'] },
            { title: 'Referees', to: '/referees', icon: 'mdi-whistle-outline', roles: ['ROLE_ADMIN'] }
        ]
    },
    {
        title: 'Clubs',
        items: [
            { title: 'Teams', to: '/teams', icon: 'mdi-account-group-outline', roles: ['ROLE_ADMIN'] },
            { title: 'Players', to: '/players', icon: 'mdi-account-outline', roles: ['ROLE_ADMIN'] },
            { title: 'Team Applications', to: '/team-applications', icon: 'mdi-application-import', roles: ['ROLE_ADMIN'] },
            { title: 'Requests', to: '/requests', icon: 'mdi-bell-outline', roles: ['ROLE_ADMIN'] },
            { title: 'Arenas', to: '/arenas', icon: 'mdi-stadium-outline', roles: ['ROLE_ADMIN'] }
        ]
    },
    {
        title: 'Content',
        items: [
            { title: 'Articles', to: '/articles', icon: 'mdi-newspaper-variant', roles: ['ROLE_ADMIN'] },
            { title: 'Philosophy', to: '/philosophy/edit', icon: 'mdi-book-variant', roles: ['ROLE_ADMIN'] },
            { title: 'Regulation', to: '/regulation/edit', icon: 'mdi-abacus', roles: ['ROLE_ADMIN'] },
            { title: 'Faqs', to: '/faqs', icon: 'mdi-frequently-asked-questions', roles: ['ROLE_ADMIN'] },
            { title: 'Rules', to: '/rules', icon: 'mdi-police-badge-outline', roles: ['ROLE_ADMIN'] }
        ]
    }
]

export function canSee(item, roles) {
    if (!item.roles || !item.roles.length) return true
    if (!roles || !roles.length) return false
    return item.roles.some(role => roles.includes(role))
}

// menu item whose section the path belongs to (/arenas/5/edit -> Arenas)
export function findMenuItem(path) {
    const segment = path.split('/')[1]
    for (const section of menuSections) {
        const item = section.items.find(menuItem => menuItem.to.split('/')[1] === segment)
        if (item) return item
    }
    return null
}
